module.exports = __webpack_public_path__ + "img/zhaoshang_banner@2x.6ef65afa.png";